module.exports = __webpack_public_path__ + "img/Ecosystem services (ESS)-Impacts to ESS.203170b6.svg";